export { default } from './EzNav.vue';
